import { all, put, takeLatest } from 'redux-saga/effects';
import {
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  SIGN_IN_VALIDATION_FAILED,
  SIGN_IN_EMAIL_NOT_VERIFIED,
  ACTIVE_COMPANY_NOT_FOUND,
} from '../actions/SigninActions';
import { defaultApi } from '../utils/axiosApi';

export function* signinAttempt(credentials) {
  const base = process.env.REACT_APP_API_BASE_URL;
  const loginEndpoint = `${base}/auth/login`;
  const credentials2 = credentials.credentials;

  const { response, error } = yield defaultApi(
    loginEndpoint,
    'POST',
    credentials2,
    true
  );

  if (response) {
    const token =
      response.data && response.data.data && response.data.data.token;
    if (!token) {
      yield put({
        type: SIGN_IN_FAILURE,
        message: 'Unexpected server response.',
      });
      return;
    }
    localStorage.setItem('access_token', token);

    // Fetch session bootstrap (companies, profile, account type, permissions).
    const me = yield defaultApi(`${base}/user/me`, 'GET', undefined, true);
    if (me.response && me.response.data && me.response.data.data) {
      const meData = me.response.data.data;
      if (meData.activeProfile && meData.activeProfile.id) {
        localStorage.setItem('active_company_id', meData.activeProfile.id);
      }
      yield put({
        type: SIGN_IN_SUCCESS,
        credentials: {
          message: response.data.message,
          data: { token, ...meData },
        },
      });
    } else {
      const { data } = me.error;
      yield put({ type: SIGN_IN_FAILURE, message: data.message });
    }
  } else if (error) {
    const { data } = error;
    if (data.status === 'validation_error') {
      yield put({
        type: SIGN_IN_VALIDATION_FAILED,
        message: data.message,
        errors: data.data,
      });
    } else if (data.status === 'email-not-verified') {
      yield put({ type: SIGN_IN_EMAIL_NOT_VERIFIED, message: data.message });
    } else if (data.status === 'company-not-found') {
      yield put({
        type: ACTIVE_COMPANY_NOT_FOUND,
        message: data.message,
        data: data.data,
      });
    } else {
      yield put({ type: SIGN_IN_FAILURE, message: data.message });
    }
  }
}

export function* signin() {
  yield takeLatest(SIGN_IN, signinAttempt);
}

export default function* rootSaga() {
  yield all([signin()]);
}
